module.exports = __webpack_public_path__ + "static/media/GrandCanyon.3cb7eb6d.jpg";